import BasicAKTableExample from "../../../../../../packages/design-system/table/examples/composed";
import AKTableExample from "../../../../../../packages/design-system/table/examples/basic";
import ExpandableExample from "../../../../../../packages/design-system/table/examples/expandable";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHcomposed from "!!raw-loader!../../../../../../packages/design-system/table/examples/composed";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHbasic from "!!raw-loader!../../../../../../packages/design-system/table/examples/basic";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHexpandable from "!!raw-loader!../../../../../../packages/design-system/table/examples/expandable";
import * as React from 'react';
export default {
  BasicAKTableExample,
  AKTableExample,
  ExpandableExample,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHcomposed,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHbasic,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHexpandable,
  React
};